
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/home/ivan/Dev/projects/BB/bigbang.hr/sentry.client.config.ts")
            }
          });